import api from './api';

export const shippingZoneService = {
  listZones: async () => {
    const response = await api.get('/admin/shipping-zones');
    return response.data?.data?.zones || [];
  },
  getZone: async (id) => {
    const response = await api.get(`/admin/shipping-zones/${id}`);
    return response.data?.data?.zone;
  },
  createZone: async (payload) => {
    const response = await api.post('/admin/shipping-zones', payload);
    return response.data?.data?.zone;
  },
  updateZone: async (id, payload) => {
    const response = await api.put(`/admin/shipping-zones/${id}`, payload);
    return response.data?.data?.zone;
  },
  deleteZone: async (id) => {
    const response = await api.delete(`/admin/shipping-zones/${id}`);
    return response.data;
  },
  listDistricts: async () => {
    const response = await api.get('/admin/districts');
    return response.data?.data?.districts || [];
  },
  setDistrictZone: async (districtId, zoneId) => {
    const response = await api.put(`/admin/districts/${districtId}/zone`, {
      zone_id: zoneId,
    });
    return response.data?.data?.district;
  },
  bulkSetDistrictZones: async (assignments) => {
    const response = await api.put('/admin/districts/bulk-zone', { assignments });
    return response.data?.data;
  },
};
